import * as F from './fonts';
import * as U from './ui';
import * as S from './style';

export const Head_1 = ({ children }) => {
  return <F.Head_1>{children}</F.Head_1>;
};

export const Head_2 = ({ children }) => {
  return <F.Head_2>{children}</F.Head_2>;
};

export const Highlight = ({ children, ...props }) => {
  return <F.Highlight {...props}>{children}</F.Highlight>;
};

export const Para = ({ children, ...props }) => {
  return <F.Para {...props}>{children}</F.Para>;
};
export const Head_3 = ({ children, ...props }) => {
  return <F.Head_3 {...props}>{children}</F.Head_3>;
};
export const Head_5 = ({ children }) => {
  return <F.Head_5>{children}</F.Head_5>;
};
export const Shadow = ({ children }) => {
  return <F.Shadow className="shadow">{children}</F.Shadow>;
};

export const Button = ({ children, ...props }) => {
  return <U.Button {...props}>{children}</U.Button>;
};
export const Wrapper_ShadHight = ({ children }) => {
  return <U.Wrapper_ShadHight className="wrapper_shadow">{children}</U.Wrapper_ShadHight>;
};
export const Input = ({ ...props }) => {
  return (
    <S.InputWrapper className={`input-${props.label}`}>
      <U.LabelInputContact htmlFor={props.label}>{props.label}</U.LabelInputContact>
      <U.Input type={props.type} placeholder={props.placeholder} />
    </S.InputWrapper>
  );
};
export const TextArea = ({ ...props }) => {
  return <U.TextArea {...props}></U.TextArea>;
};
